var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { EcdsaSecp256k1Evm, MapWithTtl, toUserId } from '@streamr/utils';
import { Lifecycle, scoped } from 'tsyringe';
import { RpcProviderSource } from '../RpcProviderSource';
import ERC1271ContractArtifact from '../ethereumArtifacts/IERC1271Abi.json';
import { createLazyMap } from '../utils/Mapping';
import { ContractFactory } from './ContractFactory';
export const SUCCESS_MAGIC_VALUE = '0x1626ba7e'; // Magic value for success as defined by ERC-1271
const CACHE_TTL = 10 * 60 * 1000; // 10 minutes
const signingUtil = new EcdsaSecp256k1Evm();
function formCacheKey(contractAddress, signerUserId) {
    return `${contractAddress}_${signerUserId}`;
}
let ERC1271ContractFacade = class ERC1271ContractFacade {
    contractsByAddress;
    publisherCache = new MapWithTtl(() => CACHE_TTL);
    constructor(contractFactory, rpcProviderSource) {
        this.contractsByAddress = createLazyMap({
            valueFactory: async (address) => {
                return contractFactory.createReadContract(address, ERC1271ContractArtifact, rpcProviderSource.getProvider(), 'erc1271Contract');
            }
        });
    }
    async isValidSignature(contractAddress, payload, signature) {
        const recoveredSignerUserId = toUserId(signingUtil.recoverSignerUserId(signature, payload));
        const cacheKey = formCacheKey(contractAddress, recoveredSignerUserId);
        const cachedValue = this.publisherCache.get(cacheKey);
        if (cachedValue !== undefined) {
            return cachedValue;
        }
        else {
            const contract = await this.contractsByAddress.get(contractAddress);
            const result = await contract.isValidSignature(signingUtil.keccakHash(payload), signature);
            const isValid = result === SUCCESS_MAGIC_VALUE;
            this.publisherCache.set(cacheKey, isValid);
            return isValid;
        }
    }
};
ERC1271ContractFacade = __decorate([
    scoped(Lifecycle.ContainerScoped),
    __metadata("design:paramtypes", [ContractFactory,
        RpcProviderSource])
], ERC1271ContractFacade);
export { ERC1271ContractFacade };
